import { Card, Typography } from "@material-tailwind/react";
import { useState } from "react";
import { useQuery } from "react-query";
import ApiRoutes from "../../services/apiRoutes";
import api from "../../services/apiService";
import DefaultLoading from "../../components/common/DefaultLoading";
import { BoatDetailsResponse } from "../../models/boat/boatDetail";
import { formatDate } from "../../utility";
import ErrorLoadingState from "../../components/common/buttons/ErrorLoadingState";
import { DefaultPagination } from "../../components/common/Pagination";
import EmptyBooking from "../../components/booking/EmptyBookingState";

function BookingTable() {
  const TABLE_HEAD = ["BoatId", "Model", "Date", "From", "To", "Amount"];
  const [, setErrorText] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { isLoading, data, error } = useQuery<BoatDetailsResponse>(
    "getBookingDetails",
    () => api.get(ApiRoutes.getBookingDetails),
    {
      onError: (error) => {
        console.log(error);
        setErrorText(error as string);
      },
      onSuccess: (data) => {
        setErrorText(null);
        console.log(data);
      },
    }
  );

  if (isLoading)
    return (
      <div className="flex items-center justify-center ">
        <DefaultLoading />
      </div>
    );

  if (error) {
    return <ErrorLoadingState />;
  }

  if (data?.data.payload.data.length === 0) {
    return (
      <div className="flex w-full justify-center items-center mt-20">
        <EmptyBooking />
      </div>
    );
  }

  const itemsPerPage = 20;
  const totalItems = data?.data.payload.data.length || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  return (
    <div>
      <Card placeholder={undefined} className="mt-14">
        <div className="overflow-x-auto">
          <table className=" table-auto text-left w-full">
            <thead>
              <tr>
                {TABLE_HEAD.map((head) => (
                  <th key={head} className="border-b border-blue-gray-100  p-4">
                    <Typography
                      placeholder={undefined}
                      variant="small"
                      color="blue-gray"
                      className="font-normal leading-none opacity-70"
                    >
                      {head}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data!.data.payload.data
                .slice(startIndex, endIndex)
                .map((boat, index) => {
                  const isLast = index === data!.data.payload.data.length - 1;
                  const classes = isLast
                    ? "p-4"
                    : "p-4 border-b border-blue-gray-50";
                  return (
                    <tr key={index}>
                      <td className={classes}>
                        <Typography
                          placeholder={undefined}
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {index + 1}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          placeholder={undefined}
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {boat.model}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          placeholder={undefined}
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {formatDate(boat.date)}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          placeholder={undefined}
                          as="a"
                          href="#"
                          variant="small"
                          color="blue-gray"
                          className="font-medium"
                        >
                          {boat.from}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          placeholder={undefined}
                          as="a"
                          href="#"
                          variant="small"
                          color="blue-gray"
                          className="font-medium"
                        >
                          {boat.to}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          placeholder={undefined}
                          as="a"
                          href="#"
                          variant="small"
                          color="blue-gray"
                          className="font-medium"
                        >
                          {boat.amount}
                        </Typography>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </Card>
      <DefaultPagination
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}

export default BookingTable;
